import React from "react";
import { Asterisk } from "lucide-react";

const phrases = [
  "ZAM Autoverkstad",
  "Din trygga bilverkstad",
  "Service & reparation",
  "Däckbyte & däckhotell",
  "AC-service",
  "Besiktningshjälp",
  "Felsökning & diagnostik",
  "Tydlig prisbild",
];

function Row() {
  return (
    <div className="flex items-center shrink-0">
      {phrases.map((p, i) => (
        <div key={i} className="flex items-center shrink-0">
          <span className="font-display italic text-[14vw] sm:text-[9vw] lg:text-[7vw] text-slate-900 whitespace-nowrap px-10 lg:px-16 leading-none">
            {p}
          </span>
          <Asterisk
            className="h-8 w-8 lg:h-14 lg:w-14 text-[#D52027] shrink-0"
            strokeWidth={1.5}
          />
        </div>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      aria-label="Editorial marquee"
      className="relative py-10 lg:py-16 border-y border-slate-200 bg-[#F8FAFC] overflow-hidden"
    >
      <div className="marquee-track">
        <Row />
        <Row />
      </div>
    </section>
  );
}
